import { fansupportPublic } from "../index";
/**
 * Asynchronous function that fetches campaign organisations.
 *
 * @return {Promise} A promise that resolves to the response data from the API.
 */
export const getCampaignOrganisations = async () => {
    return fansupportPublic.get('campaign/organisations')
};